import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-subcategories',
  templateUrl: './add-subcategories.component.html',
  styleUrls: ['./add-subcategories.component.scss']
})
export class AddSubcategoriesComponent implements OnInit {

  public mainCategories: any;
  public mainCategoryId : any
  public subCategoryName : any
  categories: any;
  currentPage = 1

  constructor(
    private apiService: ApisService, 
    private loading :LoadingService, 
    private modal : NgbModal, 
    private toastr :ToastrService , 
    private router : Router
  ) { }

  ngOnInit(): void {
    this.mainCategory()
  }


    /*----------  Main Category  ----------*/
  mainCategory() {
    this.loading.show();
    this.apiService.getMainCategories(this.currentPage).subscribe({
      next: (res) => {
       this.mainCategories == null ? this.mainCategories = res.data : this.mainCategories = [...this.mainCategories, ...res.data];
        this.loading.hide();
        if (res.data.length == 10) {
          this.currentPage++;
          this.mainCategory();
        }

      },
      error: (err) => {
        console.log("error in fetching", err);
        this.loading.hide();
      },
    });
  }

  
  
  
  /*----------  adding subcategory  ----------*/
  addCategory(){ 
    this.apiService.addSubCategory(this.subCategoryName, this.mainCategoryId).subscribe( {
      next: (res) => {
        this.toastr.success("SubCategory added successfully", "Success");
        this.close()
      } , 
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }
  

    /*=============================================
=            Modal Functions            =
=============================================*/
  close() {
    this.modal.dismissAll();
  }

  /*=====  End of Modal Functions  ======*/


}
